import { Outlet } from "react-router-dom"

const AgriculturePage = () => {
    return <Outlet />;
};

export default AgriculturePage;
